import React, { Suspense, useEffect } from 'react';
import { injectIntl } from 'react-intl-next';
import { useAnalytics } from '../../../../common/analytics';
import { messages } from './messages';
import { Flex } from '@atlaskit/primitives';
var Lozenge = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackPrefetch: true */
  /* webpackChunkName: "@atlaskit-internal_@atlassian/lozenge" */'@atlaskit/lozenge').then(function (module) {
    return {
      default: module.default
    };
  });
});
var UpsellTabWithIntl = function UpsellTabWithIntl(_ref) {
  var intl = _ref.intl,
    title = _ref.title;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  useEffect(function () {
    fireAnalyticsEvent({
      eventType: 'track',
      action: 'exposed',
      actionSubject: 'compassSearchCrossFlowExperiment',
      source: 'searchDialog'
    });
  }, [fireAnalyticsEvent]);
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    columnGap: "space.100",
    testId: "compass-upsell-modal-header"
  }, title, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Lozenge, {
    appearance: "new"
  }, intl.formatMessage(messages.compass_upsell_tab_lozenge))));
};
export var UpsellTab = injectIntl(UpsellTabWithIntl);